<template>
  <div class="table-responsive">
    <!-------------------- Tabla de Resultados -------------------->

    <table class="table table-hover">
      <thead>
        <tr>
          <th>#</th>
          <th>Tienda</th>
          <th>Tienda a Pedir</th>
          <th>Usuario</th>
          <th>Fecha</th>
          <th>Fecha Ultima Edición</th>
          <th class="text-center">Estado</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="generar_entrada(current)">
          <td>{{ current.numero }}</td>
          <td>{{ current.tienda_origen.nombre }}</td>
          <td>{{ current.tienda_destino.nombre }}</td>
          <td>
            <UsuarioEnTablaComponent :current="current.usuario" />
          </td>
          <td>{{ current.fecha }}</td>
          <td>
            <timeago :title="current.fecha_creacion" :datetime="current.fecha_creacion"></timeago>
          </td>
          <td class="text-center">
            <div data-title="Activo" data-toggle="tooltip" v-html="current.estado_str"></div>
          </td>
          <td class="text-center">
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
    <PaginationComponent :currentPage="currentPage" :data="dataTabla" @pagechanged="onPageChange" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import Notifications from "@/notifications/notifications";
import SalidaTrasladoService from "@/services/inventario/SalidaTrasladoService";

export default {
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent
  },
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: []
    };
  },
  computed: {
    ...mapGetters({
      dataTabla: "salidastraslados/salidas_traslado"
    })
  },
  mounted() {
    this.$store.dispatch("salidastraslados/fetch");
  },
  methods: {
    generar_entrada(current) {
      let self = this;
      Notifications.alert.confirm(
        "Generar Entrada de Traslado a partir de un Salida por Traslado",
        "¿Desea Generar una Entrada por Traslado partir de este Salida por traslado?",
        "Si, Generar",
        function() {
          SalidaTrasladoService.generar_entrada_traslado(current.id)
            .then((response) => {
              Notifications.alert.confirm(
                "Entrada de Traslado",
                "Ir a la Entrada Generada #.",
                "",
            function() {
              self.$router.push({
                name: "inventario-entrada_traslado-editar",
                params: { id: response.data.salida_traslado_e }
              });
              document.location.reload();
            }
              );
            })
            .catch((error) => {
              Notifications.alert.error(
                "Error al Generar Entrada por Traslado",
                error.response.data.detail
              );
            });
        }
      );
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("salidastraslados/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext
      });
    },
  }
};
</script>
